import { connect } from 'react-redux';
import App from './App';

export default connect(
  state => ({  ...state.AppState })
)(App);



/** WEBPACK FOOTER **
 ** ./src/modules/App/AppContainer.js
 **/